import { render, staticRenderFns } from "./assign.vue?vue&type=template&id=77633bc4&"
import script from "./assign.vue?vue&type=script&lang=ts&"
export * from "./assign.vue?vue&type=script&lang=ts&"
import style0 from "./assign.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports